import { controls, grouped } from "../controls";
const cnb_observations = {
  label: "Cnb Observations",
  pageLabel: "Cnb Observations", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "CNBObservation-cnb-client-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "CNBObservation-cnb-client-client_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "CNBObservation-cnb-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "CNBObservation-cnb-branch-branch_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Cnb Observation Type", star: false }),
    ...controls.oc({ tab: "general", c: "CNBObservationType", placeHolder: "Cnb Observation Type Code", name: "cnb_observation_type_code", isRequired: false, fastpath: "cnb_observation_types", autoopen: true }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "cnb_observation_type_display" }),
    ...controls.displayText({ tab: "general", label: "Inspection Status", star: false }),
    ...controls.oc({ tab: "general", c: "InspectionStatus", placeHolder: "Inspection Status Code", name: "inspection_status_code", isRequired: false, fastpath: "inspection_statuses", autoopen: true }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "inspection_status_display" }),
    ...controls.displayText({ tab: "general", label: "Remark", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "remark", isRequired: false, width: "col-sm-4", maxlength: 200 }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Cnb Observations",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Client", accessor: "CNBObservation-client-client_display", },
      { Header: "Branch", accessor: "CNBObservation-cnb-branch-branch_display", },
      { Header: "Remark", accessor: "remark", },
      { Header: "Updatedat", accessor: "updatedat", type: 'date' },
    ]
  }
};
export default cnb_observations;